<div class="p-8">
  <div *ngIf="isLoading; else sessionInfo" class="flex flex-col items-center">
    <mat-spinner class="m-auto grayscale scale-50 opacity-50"></mat-spinner>
    <span>Finalising your subscription...</span>
  </div>
  <ng-template #sessionInfo>
    <div class="text-center">
      <mat-icon class="text-green-500 scale-150">check_circle</mat-icon>
      <h1 class="text-2xl font-bold mb-2">Thank you for your subscription!</h1>
      <p class="mb-2">Your trial has started and your account is now PRO!</p>
      <p>Please to relogin to refresh your status.</p>
      <button
        mat-flat-button
        (click)="authService.logout('login')"
        class="mt-4"
      >
        Relogin as Pro
      </button>
    </div>
  </ng-template>
</div>
